// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const QuickFiltersConfig = (i18n: any) => function (config: any) {
   let filters
   let advancedFilters
   if (config.advanced_search.refine_in_options_list) {
      advancedFilters = adaptFilters([...config.advanced_search.refine_in_options_list])
   }
   if (config.toolbar?.refine_search_selection != null) {
      filters = adaptFilters(config.toolbar.refine_search_selection)
      if (config.toolbar.include_matches_full_text_default) {
         if (config.toolbar.refine_search_selection.includes('include_matches_full_text_override')) {
            filters.push({
               label: i18n.translations.INCLUDE_MATCHES_IN_FULL_TEXT,
               facet: 'include.ft.matches',
               value: true,
               applied: true //applied in this case, means either selected or the user can override
            })
         } else {
            filters.push({
               label: i18n.translations.INCLUDE_MATCHES_IN_FULL_TEXT,
               facet: 'include.ft.matches',
               value: true,
               applied: false,
               hide: true,
               defaultInclusion: true //this flag was added to distinguish case 1 from case 4 in param perspective
            })
         }
      }
      if (!config.toolbar.include_matches_full_text_default && !config.toolbar.refine_search_selection.includes('include_matches_full_text_override')) {
         filters.push({
            label: i18n.translations.INCLUDE_MATCHES_IN_FULL_TEXT,
            facet: 'include.ft.matches',
            value: false,
            applied: false, //applied in this case, means either selected or the user can override
            hide: true
         })
      }
   }

   function adaptFilters(filterArray: any) {
      const adaptedFilters: any[] = []
      filterArray.forEach((filter: any) => {
         const filterName = filter.name || filter
         let filterObject
         if (filterName === 'full_text_online') {
            filterObject = {
               label: i18n.translations.FULL_TEXT_ONLINE,
               facet: 'IsFullText',
               value: 'true'
            }
         } else if (filterName === 'limit_to_scholarly') {
            filterObject = {
               label: i18n.translations.SCHOLARLY_PEER_REVIEW,
               facet: 'IsScholarly',
               value: 'true'
            }
         } else if (filterName === 'limit_to_peer_reviewed') {
            filterObject = {
               label: i18n.translations.PEER_REVIEW,
               facet: 'IsPeerReviewed',
               value: 'true'
            }
         } else if (filterName === 'open_access') {
            filterObject = {
               label: i18n.translations.OPEN_ACCESS_FILTER,
               facet: 'IsOpenAccess',
               value: 'true'
            }
         } else if (filterName === 'items_in_catalog') {
            filterObject = {
               label: i18n.translations.LIBRARY_CATALOG,
               facet: 'SourceType',
               value: 'Library Catalog'
            }
         } else if ((filterName === 'items_at_my_institution') && config.info.institutionName) {
            filterObject = {
               label: i18n.translations.ITEMS_AT_MY_INSTITUTION,
               facet: 'Institution',
               value: config.info.institutionName
            }
         } else if (filterName === 'physical_books_only') {
            filterObject = {
               label: i18n.translations.PHYSICAL_BOOKS_LIBRARY_CATALOG,
               facet: 'print.books.only',
               value: 'true',
               disabled: false
            }
         } else if (filterName === 'ebooks_only') {
            filterObject = {
               label: i18n.translations.EBOOK_FULL_TEXT_ONLINE,
               facet: 'ebooks.only',
               value: 'true',
               disabled: false
            }
         }
         if (filterName === 'add_results_beyond_catalog') {
            filterObject = {
               label: i18n.translations.ADD_RESULTS_BEYOND_COLLECTION,
               facet: 'ho',
               value: 'f',
               disabled: false
            }
         }
         if (filterName === 'include_matches_full_text_override') {
            if (!config.toolbar.include_matches_full_text_default) {
               filterObject = {
                  label: i18n.translations.INCLUDE_MATCHES_IN_FULL_TEXT,
                  facet: 'include.ft.matches',
                  value: false,
                  applied: false //applied in this case, means either selected or the user can override
               }
            }
         }
         if (filterObject) { adaptedFilters.push(filterObject) }
      })
      return adaptedFilters
   }

   return {
      enabled: (config.facets != null) ? config.facets.quick_filters : false,
      filters,
      advancedFilters
   }
}

QuickFiltersConfig.$inject = ['translationService']

angular.module('summonApp.factories.configs')
   .factory('quickFiltersConfig', QuickFiltersConfig)
